import { runInsertNode } from '@adornis/html-based-buildify/client/helper/runInsertNode.js';
import { MenuItemGroup, type INodeConfig } from '@adornis/html-based-buildify/client/types.js';
import { isNodeSelection } from '@adornis/html-based-buildify/client/util.js';
import { HTMLBaseInstitutionProducts } from '../../../db/HTMLBaseInstitutionProductFilter.js';
import { editor } from './editor.js';
import './node-institution-products.js';

const INSTITUTION_PRODUCTS_KEY = 'institution-products';
export const institutionProductsConfig: INodeConfig = {
  node: {
    name: INSTITUTION_PRODUCTS_KEY,
    schema: {
      attrs: {
        data: { default: JSON.stringify(new HTMLBaseInstitutionProducts({}).toObject()) },
      },
      draggable: true,
      group: 'block',
      parseDOM: [
        {
          tag: 'node-institution-products',
          getAttrs(dom: HTMLElement) {
            return {
              data: dom.getAttribute('data'),
            };
          },
        },
      ],
      toDOM: node => {
        return ['node-institution-products', { data: node.attrs.data, 'no-content': 'true' }];
      },
    },
  },
  menuItems: [
    {
      group: MenuItemGroup.BASIC,
      label: 'Produktliste',
      icon: 'fact_check',
      run: view => runInsertNode(INSTITUTION_PRODUCTS_KEY)(view.state, view),
      shouldVisualize: view => {
        return !isNodeSelection(view.state.selection);
      },
    },
  ],
  editor,
};
